// // TEMPORARY: Finkeda pricing breakdown for testing only.
// // Remove/comment this section before production.

// import React from "react";

// function formatINR(val) {
//   const num = Number(val) || 0;
//   return num.toLocaleString("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });
// }

// function formatPct(val) {
//   const num = Number(val) || 0;
//   return `${num.toFixed(2)}%`;
// }

// /**
//  * Temporary Testing Component for Finkeda Pricing Breakdown.
//  * Displays dynamic backend-calculated pricing for the logged-in user:
//  * - Gateway Charge (% + ₹ amount)
//  * - Hierarchy Markup (% + ₹ amount)
//  * - Extra Markup (% + ₹ amount)
//  * - Customer Extra Markup (% + ₹ amount)
//  * - Total Customer Markup (% + ₹ amount)
//  * - Total Charges (₹ amount)
//  * - Customer Will Receive (₹ amount)
//  */
// const FinkedaPricingBreakdownBox = ({
//   amount = 0,
//   pricing = null,
//   loading = false,
//   error = "",
//   breakdown = null,
// }) => {
//   // Extract backend values directly, falling back to computed breakdown
//   const b = breakdown || {};
//   const amt = Number(amount || b.amount || 0);

//   const gatewayChargePercent = Number(
//     pricing?.pricing?.gatewayChargePercent ??
//       pricing?.gatewayChargePercent ??
//       b.gatewayChargePercent ??
//       0
//   );
//   const gatewayChargeAmount = Number(
//     b.gatewayChargeAmount != null
//       ? b.gatewayChargeAmount
//       : pricing?.pricing?.gatewayChargeAmount ??
//           pricing?.gatewayChargeAmount ??
//           (amt * gatewayChargePercent) / 100
//   );

//   const hierarchyPercent = Number(
//     pricing?.pricing?.hierarchyPercent ??
//       pricing?.hierarchyPercent ??
//       b.hierarchyPercent ??
//       0
//   );
//   const hierarchyAmount = Number(
//     b.hierarchyAmount != null
//       ? b.hierarchyAmount
//       : pricing?.pricing?.hierarchyAmount ??
//           pricing?.hierarchyAmount ??
//           (amt * hierarchyPercent) / 100
//   );

//   const extraMarkup = Number(
//     pricing?.pricing?.extraMarkup ??
//       pricing?.extraMarkup ??
//       b.extraMarkup ??
//       0
//   );
//   const extraMarkupAmount = Number(
//     b.extraMarkupAmount != null
//       ? b.extraMarkupAmount
//       : pricing?.pricing?.extraMarkupAmount ??
//           pricing?.extraMarkupAmount ??
//           (amt * extraMarkup) / 100
//   );

//   const customerExtraPercent = Number(
//     pricing?.pricing?.customerExtraPercent ??
//       pricing?.customerExtraPercent ??
//       b.customerExtraPercent ??
//       0
//   );
//   const customerExtraAmount = Number(
//     b.customerExtraAmount != null
//       ? b.customerExtraAmount
//       : pricing?.pricing?.customerExtraAmount ??
//           pricing?.customerExtraAmount ??
//           (amt * customerExtraPercent) / 100
//   );

//   const finalCustomerMarkup = Number(
//     pricing?.pricing?.finalCustomerMarkup ??
//       pricing?.finalCustomerMarkup ??
//       b.finalCustomerMarkup ??
//       hierarchyPercent + extraMarkup + customerExtraPercent
//   );
//   const finalCustomerMarkupAmount = Number(
//     b.finalCustomerMarkupAmount != null
//       ? b.finalCustomerMarkupAmount
//       : pricing?.pricing?.finalCustomerMarkupAmount ??
//           pricing?.customerCharge ??
//           (amt * finalCustomerMarkup) / 100
//   );

//   const totalChargesPercent = Number(
//     (gatewayChargePercent + finalCustomerMarkup).toFixed(2)
//   );

//   const totalCharges = Number(
//     b.totalCharges != null
//       ? b.totalCharges
//       : pricing?.totalCharges ??
//           (gatewayChargeAmount + finalCustomerMarkupAmount)
//   );

//   const customerWillReceive = Number(
//     b.customerWillReceive != null
//       ? b.customerWillReceive
//       : pricing?.beneficiaryReceive ??
//           Math.max(0, amt - totalCharges)
//   );

//   const role =
//     b.role ||
//     pricing?.performerRole ||
//     pricing?.pricing?.performerRole ||
//     "";
//   const planCode =
//     b.planCode ||
//     pricing?.planCode ||
//     pricing?.pricing?.planCode ||
//     "";

//   return (
//     <div className="rounded-xl border-2 border-dashed border-amber-500/60 bg-amber-500/5 dark:bg-amber-950/10 p-4 sm:p-5 shadow-sm text-[var(--text-dark,#0F172A)] font-mono transition-all">
//       {/* Box Header */}
//       <div className="flex flex-wrap items-center justify-between gap-2 border-b border-amber-500/30 pb-2.5 mb-3">
//         <div className="flex items-center gap-2">
//           <span className="inline-block w-2.5 h-2.5 rounded-full bg-amber-500 animate-pulse" />
//           <h3 className="text-[14px] sm:text-[15px] font-bold tracking-tight text-[var(--text-dark,#0F172A)] uppercase m-0">
//             Pricing Breakdown
//           </h3>
//         </div>
//         <div className="flex items-center gap-1.5">
//           <span className="px-2 py-0.5 rounded text-[10px] font-extrabold uppercase tracking-wide bg-amber-500 text-black shadow-xs">
//             TESTING ONLY
//           </span>
//           {planCode && (
//             <span className="px-2 py-0.5 rounded text-[10.5px] font-medium bg-blue-500/10 text-blue-600 dark:text-blue-400 border border-blue-500/20">
//               Plan: {planCode}
//             </span>
//           )}
//           {role && (
//             <span className="px-2 py-0.5 rounded text-[10.5px] font-medium bg-purple-500/10 text-purple-600 dark:text-purple-400 border border-purple-500/20">
//               Role: {role}
//             </span>
//           )}
//         </div>
//       </div>

//       {loading ? (
//         <div className="py-6 text-center text-sm text-[var(--text-muted)] animate-pulse">
//           Fetching backend pricing calculation...
//         </div>
//       ) : error ? (
//         <div className="py-3 text-center text-xs text-rose-500">
//           ⚠️ {error}
//         </div>
//       ) : (
//         <div className="space-y-2 text-[12.5px] sm:text-[13px]">
//           {/* 1. Transaction Amount */}
//           <div className="flex justify-between items-center py-1">
//             <span className="font-semibold text-[var(--text-muted,#64748b)]">
//               Transaction Amount
//             </span>
//             <span className="font-bold text-[14px] sm:text-[15px] text-[var(--text-dark,#0F172A)]">
//               ₹{formatINR(amt)}
//             </span>
//           </div>

//           <div className="border-t border-amber-500/20 my-1" />

//           {/* 2. Finkeda Gateway Charge (Clearly Separate) */}
//           <div className="flex justify-between items-center py-1">
//             <span className="text-[var(--text-muted,#64748b)] font-medium">
//               Finkeda Gateway Charge
//             </span>
//             <div className="flex items-center gap-3">
//               <span className="text-[11.5px] px-1.5 py-0.5 rounded bg-blue-500/10 text-blue-600 dark:text-blue-400 font-semibold border border-blue-500/20">
//                 {formatPct(gatewayChargePercent)}
//               </span>
//               <span className="font-semibold text-right min-w-[70px]">
//                 ₹{formatINR(gatewayChargeAmount)}
//               </span>
//             </div>
//           </div>

//           {/* 3. Hierarchy Markup */}
//           <div className="flex justify-between items-center py-1">
//             <span className="text-[var(--text-muted,#64748b)] font-medium">
//               Hierarchy Markup
//             </span>
//             <div className="flex items-center gap-3">
//               <span className="text-[11.5px] px-1.5 py-0.5 rounded bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 font-semibold border border-indigo-500/20">
//                 {formatPct(hierarchyPercent)}
//               </span>
//               <span className="font-semibold text-right min-w-[70px]">
//                 ₹{formatINR(hierarchyAmount)}
//               </span>
//             </div>
//           </div>

//           {/* 4. Extra Markup */}
//           <div className="flex justify-between items-center py-1">
//             <span className="text-[var(--text-muted,#64748b)] font-medium">
//               Extra Markup
//             </span>
//             <div className="flex items-center gap-3">
//               <span className="text-[11.5px] px-1.5 py-0.5 rounded bg-cyan-500/10 text-cyan-600 dark:text-cyan-400 font-semibold border border-cyan-500/20">
//                 {formatPct(extraMarkup)}
//               </span>
//               <span className="font-semibold text-right min-w-[70px]">
//                 ₹{formatINR(extraMarkupAmount)}
//               </span>
//             </div>
//           </div>

//           {/* 5. Customer Extra Markup */}
//           <div className="flex justify-between items-center py-1">
//             <span className="text-[var(--text-muted,#64748b)] font-medium">
//               Customer Extra Markup
//             </span>
//             <div className="flex items-center gap-3">
//               <span className="text-[11.5px] px-1.5 py-0.5 rounded bg-amber-500/10 text-amber-600 dark:text-amber-400 font-semibold border border-amber-500/20">
//                 {formatPct(customerExtraPercent)}
//               </span>
//               <span className="font-semibold text-right min-w-[70px]">
//                 ₹{formatINR(customerExtraAmount)}
//               </span>
//             </div>
//           </div>

//           <div className="border-t border-amber-500/20 my-1" />

//           {/* 6. Total Customer Markup */}
//           <div className="flex justify-between items-center py-1 font-semibold text-blue-600 dark:text-blue-400">
//             <span>Total Customer Markup</span>
//             <div className="flex items-center gap-3">
//               <span className="text-[12px] px-2 py-0.5 rounded bg-blue-600 text-white font-bold">
//                 {formatPct(finalCustomerMarkup)}
//               </span>
//               <span className="font-bold text-right min-w-[70px]">
//                 ₹{formatINR(finalCustomerMarkupAmount)}
//               </span>
//             </div>
//           </div>

//           <div className="border-t-2 border-amber-500/30 my-1" />

//           {/* 7. Total Charges (Gateway Charge + Total Markup) */}
//           <div className="flex justify-between items-center py-1 text-rose-600 dark:text-rose-400 font-semibold">
//             <div className="flex items-center gap-1.5">
//               <span>Total Charges</span>
//               <span className="text-[11px] text-[var(--text-muted,#64748b)] font-normal">
//                 (Gateway + Markup)
//               </span>
//             </div>
//             <div className="flex items-center gap-3">
//               <span className="text-[12px] px-2 py-0.5 rounded bg-rose-500/10 text-rose-600 dark:text-rose-400 font-bold border border-rose-500/20">
//                 {formatPct(totalChargesPercent)}
//               </span>
//               <span className="font-bold text-[14px] text-right min-w-[70px]">
//                 - ₹{formatINR(totalCharges)}
//               </span>
//             </div>
//           </div>

//           {/* 8. Customer Will Receive */}
//           <div className="flex justify-between items-center py-2 px-3 rounded-lg bg-emerald-500/10 border border-emerald-500/30 text-emerald-700 dark:text-emerald-400 font-bold text-[13.5px] sm:text-[14px]">
//             <span>Customer Will Receive</span>
//             <span className="text-[16px] sm:text-[18px]">
//               ₹{formatINR(customerWillReceive)}
//             </span>
//           </div>

//           {/* Footer Note */}
//           <div className="pt-2 text-[11px] text-[var(--text-muted,#64748b)] border-t border-amber-500/20 flex items-center justify-between">
//             <span>// Backend-calculated pricing</span>
//             <span>Remove before production</span>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FinkedaPricingBreakdownBox;

// TEMPORARY: Finkeda pricing breakdown for testing only.
// Remove/comment this section before production.

import React from "react";

function formatINR(val) {
  const num = Number(val) || 0;
  return num.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function formatPct(val) {
  const num = Number(val) || 0;
  return `${num.toFixed(2)}%`;
}

/**
 * Temporary Testing Component for Finkeda Pricing Breakdown.
 * Displays dynamic backend-calculated pricing for the logged-in user:
 * - Gateway Charge (% + ₹ amount)
 * - Hierarchy Markup (% + ₹ amount)
 * - Extra Markup (% + ₹ amount)
 * - Customer Extra Markup (% + ₹ amount)
 * - Total Customer Markup (% + ₹ amount)
 * - Total Charges (₹ amount)
 * - Customer Will Receive (₹ amount)
 */
const FinkedaPricingBreakdownBox = ({
  amount = 0,
  pricing = null,
  loading = false,
  error = "",
  breakdown = null,
}) => {
  // Extract backend values directly, falling back to computed breakdown
  const b = breakdown || {};
  const amt = Number(amount || b.amount || 0);

  const gatewayChargePercent = Number(
    b.gatewayChargePercent != null
      ? b.gatewayChargePercent
      : pricing?.pricing?.gatewayChargePercent ??
          pricing?.gatewayChargePercent ??
          0
  );
  const gatewayChargeAmount = Number(
    b.gatewayChargeAmount != null
      ? b.gatewayChargeAmount
      : pricing?.pricing?.gatewayChargeAmount ??
          pricing?.gatewayChargeAmount ??
          (amt * gatewayChargePercent) / 100
  );

  const hierarchyPercent = Number(
    pricing?.pricing?.hierarchyPercent ??
      pricing?.hierarchyPercent ??
      b.hierarchyPercent ??
      0
  );
  const hierarchyAmount = Number(
    b.hierarchyAmount != null
      ? b.hierarchyAmount
      : pricing?.pricing?.hierarchyAmount ??
          pricing?.hierarchyAmount ??
          (amt * hierarchyPercent) / 100
  );

  const extraMarkup = Number(
    pricing?.pricing?.extraMarkup ??
      pricing?.extraMarkup ??
      b.extraMarkup ??
      0
  );
  const extraMarkupAmount = Number(
    b.extraMarkupAmount != null
      ? b.extraMarkupAmount
      : pricing?.pricing?.extraMarkupAmount ??
          pricing?.extraMarkupAmount ??
          (amt * extraMarkup) / 100
  );

  const customerExtraPercent = Number(
    b.customerExtraPercent != null
      ? b.customerExtraPercent
      : pricing?.pricing?.customerExtraPercent ??
          pricing?.customerExtraPercent ??
          0
  );
  const customerExtraAmount = Number(
    b.customerExtraAmount != null
      ? b.customerExtraAmount
      : pricing?.pricing?.customerExtraAmount ??
          pricing?.customerExtraAmount ??
          (amt * customerExtraPercent) / 100
  );

  const finalCustomerMarkup = Number(
    b.finalCustomerMarkup != null
      ? b.finalCustomerMarkup
      : pricing?.pricing?.finalCustomerMarkup ??
          pricing?.finalCustomerMarkup ??
          hierarchyPercent + extraMarkup + customerExtraPercent
  );
  const finalCustomerMarkupAmount = Number(
    b.finalCustomerMarkupAmount != null
      ? b.finalCustomerMarkupAmount
      : pricing?.pricing?.finalCustomerMarkupAmount ??
          pricing?.customerCharge ??
          (amt * finalCustomerMarkup) / 100
  );

  const totalChargesPercent = Number(
    (gatewayChargePercent + finalCustomerMarkup).toFixed(2)
  );

  const totalCharges = Number(
    b.totalCharges != null
      ? b.totalCharges
      : pricing?.totalCharges ??
          (gatewayChargeAmount + finalCustomerMarkupAmount)
  );

  const customerWillReceive = Number(
    b.customerWillReceive != null
      ? b.customerWillReceive
      : pricing?.beneficiaryReceive ??
          Math.max(0, amt - totalCharges)
  );

  const role =
    b.role ||
    pricing?.performerRole ||
    pricing?.pricing?.performerRole ||
    "";
  const planCode =
    b.planCode ||
    pricing?.planCode ||
    pricing?.pricing?.planCode ||
    "";

  return (
    <div className="rounded-xl border-2 border-dashed border-amber-500/60 bg-amber-500/5 dark:bg-amber-950/10 p-4 sm:p-5 shadow-sm text-[var(--text-dark,#0F172A)] font-mono transition-all">
      {/* Box Header */}
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-amber-500/30 pb-2.5 mb-3">
        <div className="flex items-center gap-2">
          <span className="inline-block w-2.5 h-2.5 rounded-full bg-amber-500 animate-pulse" />
          <h3 className="text-[14px] sm:text-[15px] font-bold tracking-tight text-[var(--text-dark,#0F172A)] uppercase m-0">
            Pricing Breakdown
          </h3>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="px-2 py-0.5 rounded text-[10px] font-extrabold uppercase tracking-wide bg-amber-500 text-black shadow-xs">
            TESTING ONLY
          </span>
          {planCode && (
            <span className="px-2 py-0.5 rounded text-[10.5px] font-medium bg-blue-500/10 text-blue-600 dark:text-blue-400 border border-blue-500/20">
              Plan: {planCode}
            </span>
          )}
          {role && (
            <span className="px-2 py-0.5 rounded text-[10.5px] font-medium bg-purple-500/10 text-purple-600 dark:text-purple-400 border border-purple-500/20">
              Role: {role}
            </span>
          )}
        </div>
      </div>

      {loading ? (
        <div className="py-6 text-center text-sm text-[var(--text-muted)] animate-pulse">
          Fetching backend pricing calculation...
        </div>
      ) : error ? (
        <div className="py-3 text-center text-xs text-rose-500">
          ⚠️ {error}
        </div>
      ) : (
        <div className="space-y-2 text-[12.5px] sm:text-[13px]">
          {/* 1. Transaction Amount */}
          <div className="flex justify-between items-center py-1">
            <span className="font-semibold text-[var(--text-muted,#64748b)]">
              Transaction Amount
            </span>
            <span className="font-bold text-[14px] sm:text-[15px] text-[var(--text-dark,#0F172A)]">
              ₹{formatINR(amt)}
            </span>
          </div>

          <div className="border-t border-amber-500/20 my-1" />

          {/* 2. Finkeda Gateway Charge (Clearly Separate) */}
          <div className="flex justify-between items-center py-1">
            <span className="text-[var(--text-muted,#64748b)] font-medium">
              Finkeda Gateway Charge
            </span>
            <div className="flex items-center gap-3">
              <span className="text-[11.5px] px-1.5 py-0.5 rounded bg-blue-500/10 text-blue-600 dark:text-blue-400 font-semibold border border-blue-500/20">
                {formatPct(gatewayChargePercent)}
              </span>
              <span className="font-semibold text-right min-w-[70px]">
                ₹{formatINR(gatewayChargeAmount)}
              </span>
            </div>
          </div>

          {/* 3. Hierarchy Markup */}
          <div className="flex justify-between items-center py-1">
            <span className="text-[var(--text-muted,#64748b)] font-medium">
              Hierarchy Markup
            </span>
            <div className="flex items-center gap-3">
              <span className="text-[11.5px] px-1.5 py-0.5 rounded bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 font-semibold border border-indigo-500/20">
                {formatPct(hierarchyPercent)}
              </span>
              <span className="font-semibold text-right min-w-[70px]">
                ₹{formatINR(hierarchyAmount)}
              </span>
            </div>
          </div>

          {/* 4. Extra Markup */}
          <div className="flex justify-between items-center py-1">
            <span className="text-[var(--text-muted,#64748b)] font-medium">
              Extra Markup
            </span>
            <div className="flex items-center gap-3">
              <span className="text-[11.5px] px-1.5 py-0.5 rounded bg-cyan-500/10 text-cyan-600 dark:text-cyan-400 font-semibold border border-cyan-500/20">
                {formatPct(extraMarkup)}
              </span>
              <span className="font-semibold text-right min-w-[70px]">
                ₹{formatINR(extraMarkupAmount)}
              </span>
            </div>
          </div>

          {/* 5. Customer Extra Markup */}
          <div className="flex justify-between items-center py-1">
            <span className="text-[var(--text-muted,#64748b)] font-medium">
              Customer Extra Markup
            </span>
            <div className="flex items-center gap-3">
              <span className="text-[11.5px] px-1.5 py-0.5 rounded bg-amber-500/10 text-amber-600 dark:text-amber-400 font-semibold border border-amber-500/20">
                {formatPct(customerExtraPercent)}
              </span>
              <span className="font-semibold text-right min-w-[70px]">
                ₹{formatINR(customerExtraAmount)}
              </span>
            </div>
          </div>

          <div className="border-t border-amber-500/20 my-1" />

          {/* 6. Total Customer Markup */}
          <div className="flex justify-between items-center py-1 font-semibold text-blue-600 dark:text-blue-400">
            <span>Total Customer Markup</span>
            <div className="flex items-center gap-3">
              <span className="text-[12px] px-2 py-0.5 rounded bg-blue-600 text-white font-bold">
                {formatPct(finalCustomerMarkup)}
              </span>
              <span className="font-bold text-right min-w-[70px]">
                ₹{formatINR(finalCustomerMarkupAmount)}
              </span>
            </div>
          </div>

          <div className="border-t-2 border-amber-500/30 my-1" />

          {/* 7. Total Charges (Gateway Charge + Total Markup) */}
          <div className="flex justify-between items-center py-1 text-rose-600 dark:text-rose-400 font-semibold">
            <div className="flex items-center gap-1.5">
              <span>Total Charges</span>
              <span className="text-[11px] text-[var(--text-muted,#64748b)] font-normal">
                (Gateway + Markup)
              </span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-[12px] px-2 py-0.5 rounded bg-rose-500/10 text-rose-600 dark:text-rose-400 font-bold border border-rose-500/20">
                {formatPct(totalChargesPercent)}
              </span>
              <span className="font-bold text-[14px] text-right min-w-[70px]">
                - ₹{formatINR(totalCharges)}
              </span>
            </div>
          </div>

          {/* 8. Customer Will Receive */}
          <div className="flex justify-between items-center py-2 px-3 rounded-lg bg-emerald-500/10 border border-emerald-500/30 text-emerald-700 dark:text-emerald-400 font-bold text-[13.5px] sm:text-[14px]">
            <span>Customer Will Receive</span>
            <span className="text-[16px] sm:text-[18px]">
              ₹{formatINR(customerWillReceive)}
            </span>
          </div>

          {/* Footer Note */}
          <div className="pt-2 text-[11px] text-[var(--text-muted,#64748b)] border-t border-amber-500/20 flex items-center justify-between">
            <span>// Backend-calculated pricing</span>
            <span>Remove before production</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FinkedaPricingBreakdownBox;
